import { render } from "./userOrderModel.vue?vue&type=template&id=1f511266"
import script from "./userOrderModel.vue?vue&type=script&lang=js"
export * from "./userOrderModel.vue?vue&type=script&lang=js"

import "./userOrderModel.vue?vue&type=style&index=0&id=1f511266&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__